var exports = {
  "w": "x61f99309--463709--text_message",
};

module.exports = exports;
